define("shared/components/shared/profile-categorization/categorize-steps/industry", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper tOB--form__dropdown">
    <h2 class="tSC--card__title">
      {{t "profile_categorization.categorize_form.select_industry" displayNickname=@displayNickname}}
    </h2>
  
    <span class="qa--categorize_industry">
      {{#each @formattedIndustries as |industry|}}
        <Shared::Ui::Button
          @additional="block"
          @onClick={{fn @chooseIndustry industry}}
          @size="regular"
          @variant="outline"
          class="qa--categorize_option tSC--btn"
          {{show-on-hover "e--icon--foward"}}
        >
          {{format-profile-categorization-value industry.name industry.keyword}}
          {{svg-jar "arrow-right" class="o--icon u--float--right u--hide e--icon--foward u--fadeIn--left"}}
        </Shared::Ui::Button>
      {{/each}}
    </span>
  
    <div id="industry-search-box">
      <Shared::ProfileCategorization::CategorizeSteps::SearchBox
        @inputValue={{@otherIndustry}}
        @isManualDrop={{true}}
        @onKeyupAction={{@searchOtherIndustry}}
        @onSelectAction={{@chooseIndustry}}
        @placeholder={{t "profile_categorization.categorize_form.other_industry_placeholder"}}
        @searchResults={{@otherIndustrySearchResults}}
        @setCloseAction={{@setCloseAction}}
        @setOpenAction={{@setOpenAction}}
        @showSearchBox={{@otherIndustrySelected}}
      />
    </div>
  </div>
  
  <div class="o--btnBar">
    <Shared::Ui::Button
      @onClick={{@clearSelectedCategory}}
      @size="regular"
      @variant="mute"
      class="qa--categorize_back qa--categorize_reports_clear_text u--float--left"
    >
      <span class="u--m__r__sm">
        {{svg-jar "arrow-left" class="o--icon"}}
      </span>
      {{t "shared_words.back"}}
    </Shared::Ui::Button>
  </div>
  */
  {
    "id": "cC+EpZS4",
    "block": "[[[10,0],[14,0,\"o--formWrapper tOB--form__dropdown\"],[12],[1,\"\\n  \"],[10,\"h2\"],[14,0,\"tSC--card__title\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"profile_categorization.categorize_form.select_industry\"],[[\"displayNickname\"],[[30,1]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,1],[14,0,\"qa--categorize_industry\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,2]],null]],null],null,[[[1,\"      \"],[8,[39,3],[[24,0,\"qa--categorize_option tSC--btn\"],[4,[38,5],[\"e--icon--foward\"],null]],[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[28,[37,4],[[30,4],[30,3]],null],\"regular\",\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,6],[[30,3,[\"name\"]],[30,3,[\"keyword\"]]],null]],[1,\"\\n        \"],[1,[28,[35,7],[\"arrow-right\"],[[\"class\"],[\"o--icon u--float--right u--hide e--icon--foward u--fadeIn--left\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[3]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,1,\"industry-search-box\"],[12],[1,\"\\n    \"],[8,[39,8],null,[[\"@inputValue\",\"@isManualDrop\",\"@onKeyupAction\",\"@onSelectAction\",\"@placeholder\",\"@searchResults\",\"@setCloseAction\",\"@setOpenAction\",\"@showSearchBox\"],[[30,5],true,[30,6],[30,4],[28,[37,0],[\"profile_categorization.categorize_form.other_industry_placeholder\"],null],[30,7],[30,8],[30,9],[30,10]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n  \"],[8,[39,3],[[24,0,\"qa--categorize_back qa--categorize_reports_clear_text u--float--left\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[30,11],\"regular\",\"mute\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,1],[14,0,\"u--m__r__sm\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"arrow-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[1,[28,[35,0],[\"shared_words.back\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@displayNickname\",\"@formattedIndustries\",\"industry\",\"@chooseIndustry\",\"@otherIndustry\",\"@searchOtherIndustry\",\"@otherIndustrySearchResults\",\"@setCloseAction\",\"@setOpenAction\",\"@otherIndustrySelected\",\"@clearSelectedCategory\"],false,[\"t\",\"each\",\"-track-array\",\"shared/ui/button\",\"fn\",\"show-on-hover\",\"format-profile-categorization-value\",\"svg-jar\",\"shared/profile-categorization/categorize-steps/search-box\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/industry.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});